import http from 'api/httpClient';

export type Run = {
    id: string;
    pipeline: string;
    year: string;
    month: number;
    day: number;
    status: 'queued' | 'running' | 'succeeded' | 'failed';
    state: 'draft' | 'published' | 'deleted';
    created_by: string;
    created_at: string;
    updated_at?: string;
    error?: string;
};

export type ListRunsResponse = {
    runs: Run[];
    total: number;
};

export type CreateRunResponse = {
    run_id: string;
};

export async function listRuns(pipeline: string): Promise<ListRunsResponse> {
    return http.get(`/api/v1/admin/runs?pipeline=${encodeURIComponent(pipeline)}`);
}

export async function createRun(formData: FormData): Promise<CreateRunResponse> {
    return http.post('/api/v1/admin/runs', formData);
}

export async function getRun(runId: string): Promise<Run> {
    return http.get(`/api/v1/admin/runs/${runId}`);
}
